module.exports = __webpack_public_path__ + "static/media/carol.640df409.png";